// DOCUMENT READY //
jQuery(document).ready(function() {
    init_carousel();
    init_hovering();
    init_player_video();
    init_hovering_card();
    init_accordion();
    init_svg_convert();
    init_more_news();
    init_more_news_by_tax();
    init_tabs();
    init_filters();
    init_pagination();
    init_more_posts_in_tab();
    init_footnotes();
    init_hovering_tags();
    init_datas_fetch();
    init_menu_mobile();
    init_popin();
    init_copypaste();
    init_sitemap();
    // init_print_page();
    // init_jspdf();
});

// DOCUMENT LOAD //
jQuery(window).load(function() {
    init_sameheight();
    init_visualheight();
    get_iframe_url();
    init_slider_filter();
    // init_isotope();
});

// DOCUMENT RESIZE //
jQuery(window).resize(function() {
    init_sameheight();
    init_visualheight();
}).resize();

// DOCUMENT SCROLL //
jQuery(document).scroll(function() {

});

function init_carousel() {
    $('.slider__container').slick({
        centerMode: false,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        rows: 0,
        dots: true
    });

    $('.carousel__main').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        rows: 0,
        arrows: true,
        asNavFor: '.carousel__synch'
    });

    $('.carousel__synch').slick({
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 5,
        centerMode: false,
        arrows: false,
        rows: 0,
        variableWidth: true,
        asNavFor: '.carousel__main',
        focusOnSelect: true
    });
}

function init_sameheight() {
    if ($('.type-sameheight.for-4').size() > 0) {
        if ($(window).width() >= 500 && $(window).width() <= 991) {
            $('.type-sameheight.for-4 .type-sameheight-item').setMinHeight(2);
        } else if ($(window).width() > 991)  {
            $('.type-sameheight.for-4 .type-sameheight-item').setMinHeight(4);
        }
    }

    if ($('.type-sameheight.for-3').size() > 0) {
        if ($(window).width() >= 768 && $(window).width() <= 991) {
            $('.type-sameheight.for-3 .type-sameheight-item').setMinHeight(2);
        } else if ($(window).width() > 991)  {
            $('.type-sameheight.for-3 .type-sameheight-item').setMinHeight(3);
        }
    }

    if ($('.type-sameheight.for-2').size() > 0) {
        if ($(window).width() >= 991) {
            $('.type-sameheight.for-2 .type-sameheight-item').setMinHeight(2);
        }
    }

    if ($('.type-sameheight.for-isotope').size() > 0) {
        if ($(window).width() >= 768 && $(window).width() <= 991) {
            $('.type-sameheight.for-isotope .isotope-item[data-visibility="false"]').find('.type-sameheight-item').css('min-height', '');
            $('.type-sameheight.for-isotope .isotope-item[data-visibility="true"]').find('.type-sameheight-item').setMinHeight(2);
        } else if ($(window).width() > 991)  {
            $('.type-sameheight.for-isotope .isotope-item[data-visibility="false"]').find('.type-sameheight-item').css('min-height', '');
            $('.type-sameheight.for-isotope .isotope-item[data-visibility="true"]').find('.type-sameheight-item').setMinHeight(3);
        }
    }
}

function init_visualheight() {
    if ($('.extend-height').size() > 0 && $(window).width() >= 991) {
        var extendModel = $('.extend-model').outerHeight();

        $('.extend-height').css('min-height', extendModel);
    }
}

function init_hovering() {
    if ($('.hovering-item').size() > 0 && $(window).width() >= 992) {
        $('.hovering-item').on('mouseenter touchstart', function() {
            var self = this;

            $('.hovering-item').not(self).removeClass('active').addClass('inactive');

            if ($(self).hasClass('has-submenu')) {
                $('.hovering-content').addClass('inactive');
            }

        }).on('mouseleave touchend', function() {
            if ($('.hovering-item').hasClass('inactive')) {
                $('.hovering-item').removeClass('inactive').addClass('active');
            }

            $('.hovering-content').removeClass('inactive');
        });
    }
}

function init_hovering_card() {
    if ($('.hovering-card-item').length > 0) {
        $('.hovering-card-link').on('mouseenter touchstart', function() {
            $(this).closest('.hovering-card-item').addClass('active');
        }).on('mouseleave touchend', function() {
            $('.hovering-card-item').removeClass('active');
        });
    }
}

function init_accordion() {
    if ($('.accordion-list').length > 0) {
        $('.accordion-link').click(function(e) {
            e.preventDefault();

            $(this).closest('.accordion-item').toggleClass('active');
            $(this).parents('.accordion-item').siblings('.accordion-item').removeClass('active');

            $(this).parents('.accordion-item').siblings('.accordion-item').find('.accordion-content').slideUp();
            $(this).closest('.accordion-item').find('.accordion-content').slideToggle();
        });
    }
}

function init_player_video() {
    if ($('.module-media.type-video').length > 0) {
        $('.module-media.type-video .module-media__container').each(function() {
            var nowPlaying = $(this).find('iframe').attr('src');
            var videoCover = $(this).find('.module-media__cover');

            $(this).click(function() {
                $(this).find('iframe').attr('src', nowPlaying + '&autoplay=1');
                videoCover.hide();
            });
        });
    }
}

function get_iframe_url() {
    if ($('.module-media.type-video .module-media__container.cover-automatic').length > 0) {
        $('.module-media.type-video .module-media__container').each(function() {
            var src = $(this).find('iframe').attr('src');

            if (src) {
                var videoid = src.match(/^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((.|-){11})(?:\S+)?$/)[1];
                var thumbnailGenerated = 'https://img.youtube.com/vi/'+videoid+'/0.jpg';

                $(this).find('.module-media__cover').css('background-image', 'url(' + thumbnailGenerated + ')');
            }
        });
    }
}

function init_svg_convert() {
    $('.svg-convert').svgConvert();
}

function init_more_news() {
    var page = 1;

    $(document).on('click', '#load-system-more', function(e) {
        e.preventDefault();
        page++;

        $('.load-system-section').addClass('active');
        $('#load-system-more').parents('.load-system-section').hide();

        $.ajax({
            type: 'POST',
            url: '/wp-admin/admin-ajax.php',
            dataType: 'html',
            data: {
                'action' : 'get_news',
                'get_page' : page,
                'get_category' : $(this).data('category')
            },
            success: function(data) {
                $('.load-system-section').removeClass('active');
                if($('<div></div>').html(data).find('.load-system-item.ended').size() > 0) $('#load-system-more').parents('.load-system-section').remove();
                else $('#load-system-more').parents('.load-system-section').show();
                $('#load-system-list').append(data);
            },
            error: function(data) {

            }
        });
    });
}

function init_more_news_by_tax() {
    var page = 1;

    $(document).on('click', '#load-system-more', function(e) {
        e.preventDefault();
        page++;

        $('.load-system-section').addClass('active');
        $('#load-system-more').parents('.load-system-section').hide();

        $.ajax({
            type: 'POST',
            url: '/wp-admin/admin-ajax.php',
            dataType: 'html',
            data: {
                'action' : 'get_news_by_tax',
                'get_page' : page,
                'get_tax_name' : $(this).data('tax-name'),
                'get_tax_id' : $(this).data('tax-id')
            },
            success: function(data) {
                $('.load-system-section').removeClass('active');
                if($('<div></div>').html(data).find('.load-system-item.ended').size() > 0) $('#load-system-more').parents('.load-system-section').remove();
                else $('#load-system-more').parents('.load-system-section').show();
                $('#load-system-list').append(data);
            },
            error: function(data) {

            }
        });
    });
}

// function init_lazy() {
//     $('.lazy').lazy();
// }

function init_tabs() {
    if ($('.tab-menu').length > 0) {

        $('.tab-control').each(function(i, el) {
            var tab = $('#' + $(el).attr('data-tab'));

            $(el).click(function(e) {
                e.preventDefault();

                $(this).addClass('active').parent().siblings().find('.tab-control').removeClass('active');

                $('.tab-item').removeClass('active').removeClass('status-show');
                tab.addClass('active').addClass('status-show');

                // Remise à 0 des filtres
                if ($('.filter-result').size() > 0) {
                    $('.filter-result').removeClass('inactive');
                }

                // Relance des sliders
                if ($('.carousel__main').size() > 0) {
                    $('.carousel__main').slick('refresh');
                }

                if ($('.slider-filter').size() > 0 && $(window).width() >= 768) {
                    $('.slider-filter-' + i).slick('refresh');
                }

                // Relance du calcul des hauteurs
                init_sameheight();

                // Relance pagination
                init_pagination();

                if ($(this).hasClass('filter-isotope')) {
                    init_isotope();
                }
            });
        });
    }
}

function init_filters() {
    if ($('.filter-menu').size() > 0) {
        $('.filter-control').each(function(i, el) {
            var filter = $('#' + $(el).attr('data-filter'));

            $(el).click(function() {
                $('.filter-menu').removeClass('active');
                filter.addClass('active');
            });
        });

        $('.filter-select').each(function(i, el) {
            var select = $('.' + $(el).attr('data-select'));
            var isChecked = false;

            // Hover élement barré
            $(this).on('mouseover touchstart', function() {
                if ($(this).hasClass('scratch')) {
                    $(this).addClass('line-through');
                }
            }).on('mouseout touchend', function() {
                $(this).removeClass('line-through');
            });

            $(el).click(function(e) {
                e.preventDefault();

                $('.filter-select').not(this).removeClass('active').removeClass('scratch');
                $(this).toggleClass('active');
                isChecked = true;

                $('.filter-result').not(select).addClass('inactive');

                if ($(this).hasClass('active')) {
                    select.removeClass('inactive');
                }

                // Pagination
                $('.pagination-button').hide();

                // Remise à 0 les filtres
                if (!$(this).hasClass('active')) {
                    $('.filter-result').removeClass('inactive');
                    $('.filter-select').removeClass('scratch');
                    isChecked = false;

                    // Pagination
                    init_pagination();
                    $('.pagination-button').show();
                }

                // Element barré
                if (isChecked) {
                    $(this).addClass('scratch');
                } else {
                    $(this).removeClass('scratch');
                }
            });
        });

    }
}

function init_pagination() {
    $('.pagination-zone').each(function() {
        var that = $(this);
        var itemsCount = 0;
        var itemsElement = that.find('.pagination-list .pagination-item');
        var itemsMax = itemsElement.length;

        itemsElement.addClass('inactive');

        function showNextItems() {
            var pagination = 3;

            for (var i = itemsCount; i < (itemsCount + pagination); i++) {
                that.find('.pagination-list .pagination-item:eq(' + i + ')').removeClass('inactive');
            }

            itemsCount += pagination;

            if (itemsCount > itemsMax) {
                that.find('.pagination-button').hide();
            }
        };

        showNextItems();

        that.find('.pagination-more').on('click', function(e) {
            e.preventDefault();
            showNextItems();
        });
    });
}

function init_slider_filter() {
    if ($('.filter-list').size() > 0 && $(window).width() >= 768) {
        $('.filter-list').each(function(index) {
            // Définition des sliders
            var $slider = $('.slider-filter-' + index);
            var $btnNext = $slider.parents('.slider-filter').find('.control-next');
            var $btnPrev = $slider.parents('.slider-filter').find('.control-prev');

            $slider.on('init', function() {
                $slider.addClass('status-show');
            });

            $slider.slick({
                centerMode: false,
                arrows: true,
                prevArrow: $btnPrev,
                nextArrow: $btnNext,
                // appendArrows: $slider.parents('.slider-filter').find('.filters__controls'),
                slidesToShow: $slider.data('lg'),
                slidesToScroll: $slider.data('lg'),
                infinite: false,
                variableWidth: true,
                rows: 0,
                swipe: true,
                dots: false,
                responsive: [
                    {
                        breakpoint: 1280,
                        settings: {
                            slidesToShow: $slider.data('md'),
                            slidesToScroll: $slider.data('md')
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: $slider.data('sm'),
                            slidesToScroll: $slider.data('sm')
                        }
                    }
                ]
            });
        });
    }
}

function init_more_posts_in_tab() {
    $('.load-system-item.type-list').each(function(i, el) {
        var number = i + 1;
        var page = 1;

        if ($('.load-system-list').find('.load-system-item.ended').size() > 0) {
            $('#tab-' + number + ' .load-system-more').parents('.load-system-section').remove();
        }

        $(document).on('click', '#tab-' + number + ' .load-system-more', function(e) {
            e.preventDefault();
            page ++;

            $('#tab-' + number + ' .load-system-section').addClass('active');
            $('#tab-' + number + ' .load-system-more').parents('.load-system-section').hide();

            $.ajax({
                type: 'POST',
                url: '/wp-admin/admin-ajax.php',
                dataType: 'html',
                data: {
                    'action' : 'get_posts_in_tab',
                    'get_page' : page,
                    'get_category' : $(this).data('category'),
                    'get_postname' : $(this).data('postname')
                },
                success: function(data) {
                    $('#tab-' + number + ' .load-system-section').removeClass('active');
                    if ($('<div></div>').html(data).find('.load-system-item.ended').size() > 0) {
                        $('#tab-' + number + ' .load-system-more').parents('.load-system-section').remove();
                    } else {
                        $('#tab-' + number + ' .load-system-more').parents('.load-system-section').show();
                    }
                    $('#tab-' + number + ' .load-system-list').append(data);
                },
                error: function(data) {
                    console.log(data);
                }
            });
        });
    });
}

function init_footnotes() {
    if ($('.footnote-scan').length > 0) {
        var timer;

        $('.footnote-word').each(function(i, el) {
            var number = i + 1;
            var text = '';

            $(el).attr('data-footnote-ref', 'footnote-' + number);

            if ($(el).attr('data-footnote-text')) {
                var text = $(el).attr('data-footnote-text');
            } else {
                var text = 'Note non disponible côté JS'
            }

            $(el).append('<sup class="footnote-number p-number-sup">' + number + '</sup>');

            $('.footnote-wrapper').append('<div id="footnote-' + number + '" class="module-footnote__item footnote-item"><div class="module-footnote__inner"><div class="module-footnote__reference"><p class="module-footnote__number p-number">'+ number +'.</p></div><div class="module-footnote__content"><div class="module-footnote__text text-footnote style-wysiwyg"><p>'+ text +'</p></div></div></div></div>')

            $(el).on('mouseenter touchstart', function() {
                window.clearTimeout(timer);

                $('.footnote-wrapper').addClass('active');
                $('.footnote-item').removeClass('status-show');
                $('#' + $(el).attr('data-footnote-ref')).addClass('status-show');
            }).on('mouseleave touchend', function() {
                timer = window.setTimeout(function() {
                    $('.footnote-wrapper').removeClass('active');
                    $('.footnote-item').removeClass('status-show');
                }, 2500);
            });

            $('.footnote-item').on('mouseenter touchstart', function() {
                window.clearTimeout(timer);
                $(this).addClass('status-show');
            }).on('mouseleave touchend', function() {
                timer = window.setTimeout(function() {
                    $('.footnote-wrapper').removeClass('active');
                    $('.footnote-item').removeClass('status-show');
                }, 1500);
            });
        });
    }
}

function init_print_page() {
	$(document).on('click', '.btn-print', function(e) {
        e.preventDefault();

		window.print();
	});
}

function init_jspdf() {
    var doc = new jsPDF();

    var specialElementHandlers = {
        '#editor': function (element, renderer) {
            return true;
        }
    };

    $('.btn-pdf').click(function () {
        doc.fromHTML($('.article').html(), 15, 15, {
            'width': 170,
            'elementHandlers': specialElementHandlers
        });
        doc.save('sample-file.pdf');
    });
}

function init_hovering_tags() {
    var isChecked = false;

    if ($(window).width() > 1025) {
        $('.isotope-button').on('mouseover touchstart', function() {
            $(this).parent().siblings().find('.isotope-button').addClass('status-hide');

            if ($(this).hasClass('scratch')) {
                $(this).find('.scratch-item').css('text-decoration', 'line-through');
            }
        }).on('mouseout touchend', function() {
            $(this).parent().siblings().find('.isotope-button').removeClass('status-hide');
            $(this).find('.scratch-item').css('text-decoration', 'none');
        });
    }

    $('.isotope-button').on('click', function(e) {
        e.preventDefault();

        if (!$(this).hasClass('status-active')) {
            $(this).addClass('status-active');
            $(this).parent().siblings().find('.isotope-button').addClass('status-inactive');
            isChecked = true;
        } else {
            $(this).removeClass('status-active');
            $(this).removeClass('scratch');
            $(this).parent().siblings().find('.isotope-button').removeClass('status-inactive');
            isChecked = false;
        }

        if ($(this).hasClass('status-inactive')) {
            $(this).addClass('status-active');
            $(this).toggleClass('status-inactive');
            $(this).parent().siblings().find('.isotope-button.status-active').addClass('status-inactive').toggleClass('status-active');
            $(this).parent().siblings().find('.isotope-button').removeClass('scratch');
        }

        if (isChecked) {
            $(this).addClass('scratch');
        } else {
            $(this).removeClass('scratch');
        }
    });

    // $('.isotope-button.type-tag').on('click', function() {
    //     $('.type-subtag').removeClass('status-active scratch status-inactive');
    // });
}

function init_isotope() {
    var grid = $('.isotope-list');

    grid.isotope({
        itemSelector: '.isotope-item',
        layout: 'cellsByRow',
        percentPosition: true
    });

    var filters = {};

    // Premier démarrage du compteur
    itemCounter();

    $('.isotope-button').on('click', function(event) {
        var target = $(event.currentTarget);

        // Obtenir groupe key
        var buttonGroup = target.parents('.isotope-group');
        var filterGroup = buttonGroup.attr('data-filter-group');

        // Groupe de filtres
        filters[ filterGroup ] = target.attr('data-filter');

        // Combiner les filtres
        var filterValue = concatValues( filters );

        if (target.hasClass('type-tag')) {
            // delete filters.subtags;
            var filterValue = concatValues( filters );

            if (!target.hasClass('scratch')) {
                delete filters.tags;
                var filterValue = concatValues( filters );
                // var filterValue = concatValues( '' );
            }
        }

        if (!target.hasClass('scratch') && target.hasClass('type-subtag')) {
            delete filters.subtags;
            var filterValue = concatValues( filters );
        }

        // Système de compteur
        if (filterValue === '') {
            $('.isotope-item').attr('data-visibility', 'true');
        } else {
            $('.isotope-item').attr('data-visibility', 'false');
            $(filterValue).attr('data-visibility', 'true');
        }

        init_sameheight();
        grid.isotope({ filter: filterValue });

        // Message 'aucun résultat'
        grid.on( 'arrangeComplete', function(event, filterValue) {
            if (filterValue == 0) {
                $('.fetch-tab.type-isotope .fetch-status').addClass('show-message');
            } else {
                $('.fetch-tab.type-isotope .fetch-status').removeClass('show-message');
            }
        });

        // Fonction compteur
        itemCounter();

        // $('.tab-item.type-isotope .lazy').lazy({
        //     visibleOnly: true
        // });
    });

    // Concaténation des valeurs
    function concatValues( obj ) {
        var value = '';
        for ( var prop in obj ) {
            value += obj[ prop ];
        }
        return value;
    }

    // Compteur du nombre de posts
    function itemCounter() {
        $('.isotope-button').each(function() {
            var itemData = $(this).data('reference');
            var itemNum = $('.isotope-list .' + itemData + '[data-visibility="true"]').length;

            if (itemNum == 0) {
                $(this).addClass('status-empty');
            } else if ($(this).hasClass('status-empty')) {
                $(this).removeClass('status-empty');
            }

            $(this).find('.isotope-total').text(itemNum);
        });
    }
}

function init_datas_fetch() {
    function input_keyup() {
        var searchValue = $('#search-input').val();

        if (searchValue == 0) {
            $('.fetch-tab.type-text .search__headline').addClass('show-default');
            $('.fetch-tab.type-text .search__headline').removeClass('show-result');
            $('#fetch-list').html('');

            $.ajax({
                type: 'POST',
                url: '/wp-admin/admin-ajax.php',
                dataType: 'html',
                data: {
                    'action' : 'datas_fetch',
                    'terms' : ''
                },
                beforeSend: function () {
                    $('.fetch-tab.type-text .fetch-status').addClass('show-loader');
                    $('.fetch-tab.type-text .fetch-status').removeClass('show-message');
                },
                success: function(data) {
                    $('.fetch-tab.type-text .fetch-status').removeClass('show-loader');

                    $('#fetch-list').html(data);
                    init_sameheight();

                    gestion_message(searchValue, data);
                },
                error: function(data) {

                }
            });
        }
    }

    $('#search-input').on('keyup', function() {
        input_keyup();
    });

    $('#search-form').on('submit', function(e) {
        e.preventDefault();

        var searchValue = $('#search-input').val();

        if (searchValue.length != 0) {
            $.ajax({
                type: 'POST',
                url: '/wp-admin/admin-ajax.php',
                dataType: 'html',
                data: {
                    'action' : 'datas_fetch',
                    'terms' : searchValue
                },
                beforeSend: function () {
                    $('#search-submit').val('Recherche en cours...');
                    $('.fetch-tab.type-text .fetch-status').removeClass('show-message');
                },
                success: function(data) {
                    $('#fetch-list').html(data);
                    init_sameheight();

                    $('#fetch-list').mark(searchValue);

                    gestion_message(searchValue, data);
                },
                error: function(data) {

                }
            });
        } else {
            input_keyup();
        }
    });

    function gestion_message(searchPar, dataPar) {
        // On récupère le nombre d'item(s)
        var numResult = $('#fetch-list').find('.fetch-item').length;

        // On change le wording du bouton
        $('#search-submit').val('Rechercher');

        if (searchPar != '' || searchPar != 0) {
            // On change le message des résultats
            $('.fetch-tab.type-text .search__headline').removeClass('show-default');
            $('.fetch-tab.type-text .search__headline').addClass('show-result');

            // On injecte les infos dans le message
            $('.fetch-tab.type-text .fetch-result .fetch-term').text(searchPar);
            $('.fetch-tab.type-text .fetch-result .fetch-number').text(numResult);
        }

        if (numResult >= 2) {
            $('.fetch-tab.type-text .search__headline').addClass('show-multiple');
        } else {
            $('.fetch-tab.type-text .search__headline').removeClass('show-multiple');
        }

        if (dataPar == '') {
            $('.fetch-tab.type-text .fetch-status').addClass('show-message');
        }
    }
}

function init_menu_mobile() {
    var $overlay = $('.overlay');

    if ($(window).width() <= 992 ) {
        $('.control-open').click(function(event) {
            event.preventDefault();

            var $this = $('.control-menu');

            if ($this.hasClass('status-open')) {
                $('body').removeClass('no-overflow');
                $overlay.removeClass('status-show');
                $this.removeClass('status-open');
            } else {
                $('body').addClass('no-overflow');
                $overlay.addClass('status-show');
                $this.addClass('status-open');
            }
        });

        // Clique sur les items du menu
        $('.menu-item.has-submenu').each(function() {
            var $that = $(this);

            $that.find('.menu-link').click(function(event) {
                event.preventDefault();

                // Déploiement des sous-menus
                var $child = $(this).parents('.menu-item').find('.menu-items');
                var $others = $('.menu-items:visible').not($child);

                $child.slideToggle(200);
                $others.slideUp();

                // Animation des flèches
                $(this).parents('.menu-item').siblings('.menu-item').removeClass('status-show');
                $(this).parents('.menu-item').toggleClass('status-show');
            });
        });
    }
}

function init_popin() {
    var $overlay = $('.overlay');

    $('.popin-control').each(function(i, el) {
        var $modal = $('#' + $(el).attr('data-modal'));
        var $close = $('.popin-close');
        var $overlay = $('.overlay');

        function removeModal() {
            $modal.removeClass('status-show');
            $overlay.addClass('status-locked').removeClass('status-show');
            $('body').removeClass('no-overflow');
        }

        function removeModalHandler() {
            removeModal();
        }

        $(el).click(function(e) {
            e.preventDefault();
            $modal.addClass('status-show');
            $overlay.removeClass('status-locked').addClass('status-show');
            $('body').addClass('no-overflow');
        });

        $close.click(function(e) {
            if($(e.target).hasClass('popin-close')) {
                e.preventDefault();
                removeModalHandler();
            }
        });

    });
}

function init_copypaste() {
	var copyButton = $('.btn-copypaste');

	$(copyButton).click( function(e) {
        e.preventDefault();

		var urlToCopy = $(this).data('copy-url');
		copyToClipboard(urlToCopy);
        $('.popin-alert').addClass('status-show');
        setTimeout(function() {
            $('.popin-alert').removeClass('status-show');
        }, 5000);
		// alert('Le lien vers l\'article a bien été copié');
	});

	function copyToClipboard(textToCopy) {
		var elem = document.createElement("input");
		elem.setAttribute("value", textToCopy);
		document.body.appendChild(elem);
		elem.select();
		document.execCommand("copy");

		document.body.removeChild(elem);
	}
}

function init_sitemap() {
    if ($('.page-sitemap').size() > 0) {
        $('.sitemap-control').each(function(index, el) {
            var $that = $(this);

            $that.click(function(event) {
                event.preventDefault();

                $that.toggleClass('status-open');
                $that.parents('.sitemap-item').children('.sitemap-list:first').toggleClass('status-open');
            });
        });
    }
}
